import EventClass from "common/utils/ui/event-class";
import DesignUploadCtaPlpCookieClass from "components/jiffy/design-upload-cta/design-upload-cta-plp/design-upload-cta-plp-cookie-class";
import ProductCardMadeCanvasClass from "../made-canvas/made-canvas-class";

export default class ColorSwatchHoverClass extends EventClass {
  #$target;

  get #$productPreview() {
    return this.#$productCard?.querySelector(".js-product-image");
  }

  get #$productCard() {
    return this.#$target.closest(".js-product-card-v3");
  }

  event(event, $target) {
    super.event(event, $target);

    this.#$target = $target;
    const { imgSrc, printableArea, frontZoomedImageUrl } = this.#$target.dataset;

    if (this.#$productPreview) {
      const url = DesignUploadCtaPlpCookieClass.previewUrl;
      if (url && frontZoomedImageUrl && printableArea) {
        this.#$productPreview.src = frontZoomedImageUrl;
        this.#$productPreview.dataset.printableArea = printableArea;
        this.#$productPreview.dataset.frontZoomedImageUrl = frontZoomedImageUrl;
        new ProductCardMadeCanvasClass({ url }).initSingle(this.#$productPreview);
      } else {
        this.#$productPreview.src = imgSrc;
      }
    }
  }
}
